export enum EMatchingRibbonType {
  NORMAL = 0,
  SLIM = 1,
}
